import { render, staticRenderFns } from "./GoCrazyControl.vue?vue&type=template&id=5e7f5433&scoped=true&"
import script from "./GoCrazyControl.js?vue&type=script&lang=js&"
export * from "./GoCrazyControl.js?vue&type=script&lang=js&"
import style0 from "./GoCrazyControl.scss?vue&type=style&index=0&id=5e7f5433&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7f5433",
  null
  
)

export default component.exports